import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Picto4() {
	const classes = useStyles();

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.95 49.78" width="47px">
			<g id="Calque_2" data-name="Calque 2">
				<g id="design">
					<path
						class="cls-1"
						d="M59.17,22.52a.67.67,0,0,0-.89.19,4,4,0,0,1-2.7,2.05,5,5,0,0,1-3.79-1,.21.21,0,0,0-.19-.07,16.82,16.82,0,0,0-6.42-9.43c-.06-.07-.06-.07-.13-.07a9.08,9.08,0,0,0,.58-3.27c0-5.78-5-10.52-11.1-10.52a11,11,0,0,0-11,9,.61.61,0,0,0-.32-.06,26.42,26.42,0,0,0-4.94,1.22C16.11,9,12.26,7.43,5.78,8.14a.66.66,0,0,0-.52.32.65.65,0,0,0,0,.58c.45.77.9,1.48,1.35,2.18a11.72,11.72,0,0,1,2.25,5.33A15.35,15.35,0,0,0,5.2,23.09H2.7A2.57,2.57,0,0,0,.39,25.85v7.38c0,1.93,1.86,1.93,2.76,1.93H6.1a11.14,11.14,0,0,0,6.54,6l-1.41,6.35a1.35,1.35,0,0,0,.32,1.29,1.82,1.82,0,0,0,1.54.64L20,49.34h0a2.46,2.46,0,0,0,2.32-1.73L23,44.4A34.42,34.42,0,0,0,34,44.4l.77,3.28A2.33,2.33,0,0,0,37,49.34h0l6.93.07h0a2,2,0,0,0,1.48-.64,1.61,1.61,0,0,0,.32-1.29l-1.48-7c5.07-3.4,8-8.35,8-13.61a14.51,14.51,0,0,0-.13-1.67,5.91,5.91,0,0,0,3,.84,6,6,0,0,0,1-.13,5.88,5.88,0,0,0,3.53-2.63A.76.76,0,0,0,59.17,22.52ZM34.53,1.66a9.51,9.51,0,0,1,9.82,9.24c0,5.13-4.43,9.24-9.82,9.24S24.71,16,24.71,10.9,29.07,1.66,34.53,1.66ZM43,39.78a.63.63,0,0,0-.26.64l1.61,7.45a.43.43,0,0,1-.07.25.71.71,0,0,1-.51.2l-6.93-.07h0a1.14,1.14,0,0,1-1-.7L35,43.76a.64.64,0,0,0-.71-.51,36.13,36.13,0,0,1-11.74,0,.64.64,0,0,0-.71.51l-.9,3.72a1.09,1.09,0,0,1-1,.77h0L13,48.32a.77.77,0,0,1-.52-.2c-.06-.06-.06-.12-.06-.25l1.54-6.93a.7.7,0,0,0-.45-.77,9.82,9.82,0,0,1-6.42-5.78A.61.61,0,0,0,6.48,34H3.15c-1.29,0-1.48-.13-1.48-.65V25.92a1.28,1.28,0,0,1,.26-1,1.1,1.1,0,0,1,.89-.45H5.71A.63.63,0,0,0,6.35,24a15,15,0,0,1,3.73-6.67.73.73,0,0,0,.19-.52,12.92,12.92,0,0,0-2.5-6.22c-.26-.39-.52-.83-.77-1.22,5.77-.45,9.05,1.09,10.84,2.44a.76.76,0,0,0,.64.13,27.52,27.52,0,0,1,5-1.29h0v.2c0,5.77,5,10.52,11.1,10.52a11,11,0,0,0,10-6c4,3.14,6.22,7.25,6.22,11.68C50.77,31.89,47.94,36.57,43,39.78Z"
					/>
					<circle class="cls-1" cx="12.32" cy="22.07" r="1.03" />
					<path
						class="cls-2"
						d="M34.84,15.09a3.83,3.83,0,0,1-4-3.05h-1.6l.46-1.23h1V9.89H29.26l.46-1.22H31a4.19,4.19,0,0,1,4.28-3,4.6,4.6,0,0,1,2.22.53l.07.08L37,7.75l-.15-.15a2.46,2.46,0,0,0-1.61-.53,2.34,2.34,0,0,0-2.29,1.52h3.44l-.46,1.23H32.62v.92h2.91L35.07,12H33a2.18,2.18,0,0,0,2.15,1.38,2.89,2.89,0,0,0,2-.85l.08-.07,1,1.53-.07.07A5.44,5.44,0,0,1,34.84,15.09Z"
					/>
				</g>
			</g>
		</svg>
	);
}
